import { configureRequest } from '@/networkRequests/apiClient/apiClient.functions'
import urls from '@/networkRequests/apiClient/endpoints'
import { getUserRole } from '@/shared/functions/UserRole/userRoleManagment.functions'
import { createAsyncThunk } from '@reduxjs/toolkit'

import {
  ConfirmExtractedItineraryRequestPayload,
  ConfirmExtractedItinerarySuccessResponse
} from './confirmExtractedItinerary.types'

interface ApiResponse<T> {
  status: number
  data: T
  message?: string
}

export const confirmExtractedItinerary = createAsyncThunk(
  urls.flights.confirmExtractedItinerary,
  async (payload: ConfirmExtractedItineraryRequestPayload, { rejectWithValue }) => {
    try {
      const response = (await configureRequest({
        method: 'POST',
        url: urls.flights.confirmExtractedItinerary,
        data: {
          tripType: payload.tripType,
          cabinClass: payload.cabinClass,
          tripPrice: payload.tripPrice,
          tripCurrency: payload.tripCurrency,
          slices: payload.slices,
          offerRequestId: payload.offerRequestId,
          extractionAttemptId: payload.extractionAttemptId
        },
        headers: {
          'Content-Type': 'application/json',
          'X-User-Role': getUserRole() || ''
        }
      })) as ApiResponse<ConfirmExtractedItinerarySuccessResponse>

      // Extract data from API response wrapper
      if (response.status >= 200 && response.status < 300) {
        // Response has structure: { status, data, message, ... }
        const responseData = (response.data || response) as ConfirmExtractedItinerarySuccessResponse

        if (payload.onSuccess) {
          payload.onSuccess()
        }

        return responseData
      }

      throw response
    } catch (error) {
      const err = error as { response?: { data?: { userFriendlyMessage?: string } }; message?: string }
      const message = err?.response?.data?.userFriendlyMessage || err?.message || 'Failed to confirm itinerary'

      return rejectWithValue(message)
    }
  }
)
